import { RouteFragment } from "@impero-com/common/routeFragments";
import { TableRestoreConfig, withRestoreParam } from "@impero-com/ui/domain";
import * as Sentry from "@sentry/react";

import { WebRoute } from "../../routes";

import {
    buildEntityProgramsListTableStateStorageKey,
    entityProgramsListColumnFiltersCodecMap,
    entityProgramsListTableDefaultValues,
} from "./view/list/consts";

export const controlEntitiesListUrl = withRestoreParam(WebRoute.ENTITIES);

export const buildEntityProgramsListUrl = (controlEntityId: number) =>
    withRestoreParam(
        `${WebRoute.ENTITIES}/${controlEntityId}/${RouteFragment.CONTROL_PROGRAMS}`
    );

export function buildEntityProgramsListRestoreConfig(
    controlEntityId: number
): TableRestoreConfig {
    return {
        tableId: buildEntityProgramsListTableStateStorageKey(controlEntityId),
        defaultValues: entityProgramsListTableDefaultValues,
        codecMap: entityProgramsListColumnFiltersCodecMap,
        onError: Sentry.captureException,
    };
}
